// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import { normalizeBorderRadius } from 'church-theme-library/utilities/normalize'

class ImageGallery extends React.Component {
	renderItems = () => {
		const { items, columns, borderRadius, boxShadow } = this.props
		let { innerSpacing } = this.props

		if ( ! items ) {
			return null
		}

		const itemsKeys = Object.keys( items )
		const itemsNumber = itemsKeys.length
		let wrapStyle = {}

		if ( innerSpacing ) {
			innerSpacing = parseInt( innerSpacing, 10 )
			wrapStyle.margin = '-' + innerSpacing / 2 + 'px'
		}

		let columnsArray = []

		if ( columns ) {
			if ( columns.includes( ',' ) ) {
				columnsArray = columns.split( ',' ).filter( Boolean )
			} else {
				columnsArray = columns.split( ' ' ).filter( Boolean )
			}
		}

		let markup = [],
			rowsMarkup = []

		if ( columnsArray.length && items ) {
			// Render as rows based on the columns setting.
			// Accepts a comma separated value, to render different columns numbers per row.
			// When the last number is reached, repeat using the final number.
			// Eg: "3".
			// Eg: "3,2,3,1".

			let itemsNumberRemaining = itemsNumber
			let nextItemKeyIndex = -1
			let columnNumbersRemaining = columnsArray.length
			let rowImagesN = 0

			columnsArray.map( columnsNumber => {
				// One set of columns number.
				columnNumbersRemaining--
				columnsNumber = parseInt( columnsNumber, 10 )
				rowImagesN = columnsNumber
				let rowMarkup = []
				let columnsNumberArray = [ ...Array( columnsNumber ) ]

				// Row:
				// Add n images for this row.
				columnsNumberArray.map( i => {
					itemsNumberRemaining--
					nextItemKeyIndex++

					rowMarkup.push( this.renderItem( items[ itemsKeys[ nextItemKeyIndex ] ], innerSpacing, columnsNumber, borderRadius, boxShadow ) )
				} )

				rowsMarkup.push(
					<div className="image-gallery-row" key={ columnNumbersRemaining }>
						{ rowMarkup }
					</div>
				)

				// If there are no columns numbers left, use the last number for the rest.
				if ( columnNumbersRemaining <= 0 ) {
					let rowsLeftN = Math.ceil( itemsNumberRemaining / rowImagesN )

					if ( rowsLeftN > 0 ) {
						let rowsLeftArray = [ ...Array( rowsLeftN ) ]

						if ( rowsLeftArray.length ) {
							rowsLeftArray.map( i => {
								// Row:
								rowMarkup = []
								columnsNumberArray = [ ...Array( columnsNumber ) ]

								columnsNumberArray.map( i => {
									itemsNumberRemaining--
									nextItemKeyIndex++

									rowMarkup.push( this.renderItem( items[ itemsKeys[ nextItemKeyIndex ] ], innerSpacing, columnsNumber, borderRadius, boxShadow ) )
								} )

								rowsMarkup.push(
									<div className="image-gallery-row" key={ i }>
										{ rowMarkup }
									</div>
								)
							} )
						}
					}
				}
			} )
		} else if ( items ) {
			markup = Object.keys( items ).map( key => {
				let item = items[ key ]

				return this.renderItem( item, innerSpacing, false, borderRadius, boxShadow )
			} )
		}

		return (
			<div className="image-gallery-items-wrap" style={ wrapStyle }>
				<div className="image-gallery-items">
					{ rowsMarkup }
					{ markup }
				</div>
			</div>
		)
	}

	renderItem = ( item, innerSpacing, columnsNumber = false, borderRadius = '', boxShadow = '' ) => {
		if ( ! item ) {
			return null
		}

		let itemStyle = {}
		let pushStyle = {}
		let imageStyle = {}

		if ( columnsNumber ) {
			itemStyle = {
				flexBasis: 100 / columnsNumber + '%'
			}

			if ( innerSpacing ) {
				itemStyle.padding = innerSpacing / 2 + 'px'
			}
		} else {
			let widthVal = item.width * 150 / item.height
			let paddingBottom = item.height / item.width * 100 + '%'

			if ( ! widthVal ) {
				return null
			}

			itemStyle = {
				width: widthVal + 'px',
				flexGrow: widthVal
			}
			pushStyle = {
				paddingBottom: paddingBottom
			}

			if ( innerSpacing ) {
				itemStyle.margin = innerSpacing / 2 + 'px'
			}
		}

		if ( innerSpacing ) {
			itemStyle.padding = innerSpacing / 2 + 'px'
		}

		if ( borderRadius ) {
			imageStyle.borderRadius = normalizeBorderRadius( borderRadius )
		}

		if ( boxShadow ) {
			imageStyle.boxShadow = boxShadow
		}

		return (
			<div className="image-gallery-item" style={ itemStyle } key={ item.id }>
				<img src={ item.url } alt={ item.alt } style={ imageStyle } />

				<div style={ pushStyle } />
			</div>
		)
	}

	render() {
		return (
			<div className="image-gallery">
				<div className="image-gallery-inner">
					{ this.renderItems() }
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		connection: state.site.connection
	}
}

export default connect( mapStateToProps )( ImageGallery )
